var E = Object.defineProperty;
var _ = (t, o, r) => o in t ? E(t, o, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[o] = r;
var s = (t, o, r) => _(t, typeof o != "symbol" ? o + "" : o, r);
import { S as f } from "./sentry.js";
const a = "__abort_error__";
var n, e, i;
class c extends (i = Error, e = a, n = f, i) {
  constructor() {
    super(...arguments);
    s(this, e, !0);
    s(this, n, !1);
  }
  static is(r) {
    return r instanceof c || !!r && typeof r == "object" && a in r;
  }
}
function R(t) {
  return t instanceof Error && t.name === "AbortError";
}
export {
  c as A,
  R as i
};
//# sourceMappingURL=abort.js.map
